/**
 * Custom-question config for the public lead form.
 *
 * To change the form: edit the `LEAD_FORM_FIELDS` array below, commit, push.
 * Each entry's `key` becomes the column key under `Lead.customFields[]`.
 * The `label` is preserved per submission so old leads keep their original
 * question wording even after the live form changes.
 *
 * The four core fields (name, email, phone, description) are NOT defined
 * here — they live in the form component because they're required and
 * fixed.
 */

export type LeadFieldType = 'text' | 'textarea' | 'select';

export interface LeadFieldConfig {
  key: string;
  label: string;
  type: LeadFieldType;
  required?: boolean;
  placeholder?: string;
  options?: ReadonlyArray<{ value: string; label: string }>;
  /** Optional helper shown under the field. */
  help?: string;
}

export const LEAD_FORM_FIELDS: ReadonlyArray<LeadFieldConfig> = [
  {
    key: 'companyName',
    label: 'Company name',
    type: 'text',
    required: true,
    placeholder: 'Acme Inc.',
  },
  {
    key: 'timeline',
    label: 'When do you need this live?',
    type: 'select',
    required: false,
    options: [
      { value: '', label: "I'm not sure yet" },
      { value: 'asap', label: 'ASAP' },
      { value: '1-month', label: 'Within 1 month' },
      { value: '1-3-months', label: '1 – 3 months' },
      { value: '3-plus-months', label: '3+ months' },
    ],
  },
];
